/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,jsx-a11y/role-supports-aria-props */
import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import { useDispatch } from "react-redux";
import { shallowEqual, useSelector } from "react-redux";
import * as actions from "../../../_redux/guiAwards/guiAwardsActions";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../../../_metronic/_partials/controls";
import { GuiAwardEditForm } from "./GuiAwardEditForm";
import { useSubheader } from "../../../../../../_metronic/layout";
import { ModalProgressBar } from "../../../../../../_metronic/_partials/controls";
import { KTUtil } from "../../../../../../_metronic/_assets/js/components/util";
import KTLayoutQuickForm from "../../../../Admin/utils/quick-form";
import {GuideProfile} from "../../profile/GuideProfile";
import axios from "axios";

const initGuiAward = {
  id: undefined,
  guideId: 0,
  awardTitle: "",
  awardDate: "2020-10-17T04:16:37.559Z",
  remark: "",
  uplaodDoc: "",
  remark1: "",
 
};
export default function GuiAwardEdit({
  history,
  match: {
    params: { id,gid },
  },
}) {
  useLayoutEffect(() => {
    KTUtil.ready(function() {
      KTLayoutQuickForm.init("kt_quick_form");
    });
  }, []);
  // Subheader
  const subheader = useSubheader();

  // Tabs
  // const [tab, setTab] = useState("basic");
  const [title, setTitle] = useState("");
  const dispatch = useDispatch();
  // const layoutDispatch = useContext(LayoutContext.Dispatch);
  const { actionsLoading, guiAwardForEdit } = useSelector(
    (state) => ({
      actionsLoading: state.guiAwards.actionsLoading,
      guiAwardForEdit: state.guiAwards.guiAwardForEdit,
    }),
    shallowEqual
  );

  useEffect(() => {
    dispatch(actions.fetchGuiAward(id));
  }, [id, dispatch]);

  useEffect(() => {
    let _title = id ? "" : "New Guide Award";
    if (guiAwardForEdit && id) {
      _title = `Edit Guide Award `;
    }

    setTitle(_title);
    subheader.setTitle(_title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [guiAwardForEdit, id]);

  const saveGuiAward = (values) => {
    if (!id) {
      dispatch(actions.createGuiAward(values)).then(() =>
        backToGuiAwardsList()
      );
    } else {
      dispatch(actions.updateGuiAward(values)).then(() =>
        backToGuiAwardsList()
      );
    }
  };

  const btnRef = useRef();
  const saveGuiAwardClick = () => {
    if (btnRef && btnRef.current) {
      btnRef.current.click();
    }
  };


  const id1 = id===undefined?'':id
  const GuideUrl = `${process.env.REACT_APP_API_URL}/api/guiAward/${id1}`;

  const [guide, setGuide] = useState([]);

  useEffect(() => {
    const getGuide = async () => {
      const response = await axios.get(GuideUrl);
      setGuide(response.data);
    };
    getGuide();
  }, [setGuide,GuideUrl]);


  const GuideId = gid?gid:guide.guideId;
 
 
 
  initGuiAward.guideId=GuideId;

  console.log(GuideId)

  const backToGuiAwardsList = () => {
    history.push(`/guide/guideprofile`);
  };

  return (
    <div>
      <GuideProfile />
      <div
        id="kt_quick_form"
        className="offcanvas offcanvas-right offcanvas offcanvas-on offcanvas-sm"
      >
        <div className="offcanvas-content pr-5 mr-n5">
          <Card>
            {actionsLoading && <ModalProgressBar />}
            <CardHeader title={title}>
              <CardHeaderToolbar>
                <button
                  type="button"
                  onClick={backToGuiAwardsList}
                  className="btn btn-light"
                >
                  <i className="fa fa-times"></i>
                  Close
                </button>
                {/* <button className="btn btn-light ml-2">
                    <i className="fa fa-redo"></i>
                    Reset
                  </button> */}
                <button
                  type="submit"
                  className="btn btn-primary ml-2"
                  onClick={saveGuiAwardClick}
                >
                  Save
                </button>
              </CardHeaderToolbar>
            </CardHeader>
            <CardBody>
              {!actionsLoading && (
                <GuiAwardEditForm
                  actionsLoading={actionsLoading}
                  guiAward={guiAwardForEdit || initGuiAward}
                  btnRef={btnRef}
                  saveGuiAward={saveGuiAward}
                />
              )}
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
